import {reactive} from 'vue'
import {regId} from '@/utils/reg'
import {scopeSearchApi} from '@/api/common'

export default function(){
  function checkCardNumber(rule:any, value:any, callback:any){
    if (!regId.test(value)) {
      return callback(new Error('请填写正确的身份证号码'));
    }else{
      callback()
    }
  }
  const rawData = reactive({
    isEmpty:true,
    user:{
      Name:"",
      CardNumber:""
    },
    score:null,
    rules:{
      CardNumber: [
        { required: true, message: '这是一个必填项', trigger: 'blur' },
        { validator: checkCardNumber, trigger: 'blur' }
      ],
      Name: [
        { required: true, message: '这是一个必填项', trigger: 'blur' }
      ],
    }
  })


  function scopeSearch(){
    const data = rawData.user
    scopeSearchApi(data).then((res:any)=>{
      if(res && res.state ===0){
        rawData.score = res.content
      }else{
        rawData.isEmpty = true
      }
    })
  }


  return {rawData,scopeSearch}
}